import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { ADMIN_TRAIN } from "@/constants/testIds";

export default function AdminAccessLogs() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/training/access-logs?limit=200")
       .then((r) => setLogs(r.data))
       .catch((e) => setErr(apiErrorMessage(e)));
  }, []);
  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Training admin</div>
        <h1 className="headline-xl">Access logs</h1>
        <p className="text-lifted-dim mt-2 text-sm">Every access-code attempt (successful and failed) is recorded immutably.</p>
      </header>
      {err && <div className="text-rose-300 text-sm">{err}</div>}
      <div data-testid={ADMIN_TRAIN.accessLogs} className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Code</th>
              <th className="px-4 py-3">Result</th>
              <th className="px-4 py-3">Reason</th>
              <th className="px-4 py-3">Actor</th>
              <th className="px-4 py-3">IP</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-white/5">
                <td className="px-4 py-3 text-xs text-lifted-dim whitespace-nowrap">{l.at}</td>
                <td className="px-4 py-3"><code className="text-lifted-green text-xs">{l.code || "—"}</code></td>
                <td className="px-4 py-3">
                  {l.success
                    ? <span className="chip chip--green">Success</span>
                    : <span className="chip" style={{ background: "rgba(244,63,94,.15)", color: "#fca5a5" }}>Fail</span>}
                </td>
                <td className="px-4 py-3 text-xs text-lifted-dim">{l.reason}</td>
                <td className="px-4 py-3 text-xs text-lifted-dim">{l.email || l.actor_id || "—"}</td>
                <td className="px-4 py-3 text-xs text-lifted-mute">{l.ip}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-lifted-mute">No attempts yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
